'use client';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
export const ProductContactDealerWrapper = ({
  children,
  mobile
}: {
  children: React.ReactNode;
  mobile: React.ReactNode;
}) => {
  const isSM = useBreakpoint(PAGE_BREAKPOINTS.SM);

  return <>{isSM !== undefined && isSM ? children : mobile}</>;
};
